import { random, shuffle } from 'lodash';

export const PROFILE_BACKGROUNDS_COLOR_SCHEME = {
    TEAL: 'linear-gradient(180deg, #71B6CF 0%, #67D6DC 100%)',
    MAGENTA: 'linear-gradient(180deg, #BE41AB 0%, #DF3499 100%)',
    PURPLE: 'linear-gradient(180deg, #7E76D4 0%, #B0B0D7 100%)',
    BLUE: 'linear-gradient(180deg, #297DE4 0%, #87ACE5 100%)',
    YELLOW: 'linear-gradient(180deg, #F4BD25 0%, #F1DF3D 100%)',
    GREEN: 'linear-gradient(180deg, #6BA26D 0%, #63B561 100%)',
};

const backgrounds = Object.keys(PROFILE_BACKGROUNDS_COLOR_SCHEME);

const filterBackgrounds = (background) => backgrounds.filter((bg) => bg !== background);

export const getUniqueColorMap = () => (shuffle(Object.keys(PROFILE_BACKGROUNDS_COLOR_SCHEME)))
    .map((key) => PROFILE_BACKGROUNDS_COLOR_SCHEME[key]);

export const getProfileBackgrounds = (numberOfProfiles) => {
    let lastBackground;
    const profileBackgrounds = [];

    for (let i = 0; i < numberOfProfiles; i++) {
        const bgIndex = random(0, backgrounds.length - 2);
        const filteredBackgrounds = filterBackgrounds(lastBackground);

        lastBackground = filteredBackgrounds[bgIndex];
        profileBackgrounds.push(lastBackground);
    }

    return profileBackgrounds.map((key) => PROFILE_BACKGROUNDS_COLOR_SCHEME[key]);
};
export const getRandomProfileBackground = () => {
    const randomNumber = Math.round(Math.random() * (backgrounds.length - 1));

    return PROFILE_BACKGROUNDS_COLOR_SCHEME[backgrounds[randomNumber]];
};
